import React from "react";
import styled from "styled-components";

function ConvergenceImportPreview({ previewData, programData, onConfirm, onClose }) {
  return (
    <Overlay>
      <Modal>
        <Header>
          <h3>📄 Import Preview</h3>
          <CloseButton onClick={onClose}>×</CloseButton>
        </Header>

        <Content>
          {previewData.length === 0 ? (
            <p>No data to preview.</p>
          ) : (
            previewData.map((program, index) => (
              <div key={index} style={{ marginBottom: "24px" }}>
                <ProgramTitle>{program.program}</ProgramTitle>
                <table>
                  <thead>
                    <tr>
                      <th>Indicator</th>
                      <th>2024 Status</th>
                      <th>2025 Target</th>
                      {Array.from({ length: 12 }, (_, i) => (
                        <th key={i}>M{i + 1}</th>
                      ))}
                      <th>Total</th>
                      <th>Status to Date</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {program.data.map((entry, i) => (
                      <tr key={i}>
                        <td>{entry.indicator}</td>
                        <td>{entry.status2024}</td>
                        <td>{entry.target2025}</td>
                        {entry.months.map((monthVal, mi) => (
                          <td key={mi}>{monthVal}</td>
                        ))}
                        <td>{entry.total}</td>
                        <td>{entry.statusToDate}</td>
                        <td>{entry.remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))
          )}
        </Content>

        <Actions>
          <ConfirmButton onClick={onConfirm}>✔ Confirm Import</ConfirmButton>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        </Actions>
      </Modal>
    </Overlay>
  );
}

export default ConvergenceImportPreview;

// Styles
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Modal = styled.div`
  background: white;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
  border-radius: 8px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  margin-bottom: 16px;

  h3 {
    margin: 0;
  }
`;

const CloseButton = styled.button`
  background: none;
  font-size: 22px;
  border: none;
  cursor: pointer;
`;

const ProgramTitle = styled.h4`
  margin-bottom: 6px;
  color: #2e7d32;
`;

const Content = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;

    th, td {
      border: 1px solid #ccc;
      padding: 6px;
      text-align: center;
      font-size: 13px;
    }

    th {
      background: #f0f0f0;
    }
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const ConfirmButton = styled.button`
  padding: 8px 16px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

const CancelButton = styled.button`
  padding: 8px 16px;
  background-color: #aaa;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;
